import { createStyles } from "@material-ui/core";

export default () => createStyles({
    toolbar: {
        justifyContent: 'flex-end'
    }
});
